/**
 * Response Constants
 */

export const HTTP_RESPONSE_SUCCESS = 200;

export const HTTP_RESPONSE_UNAUTHORIZED = 401;

export const HTTP_RESPONSE_INTERNAL_SERVER_ERROR = 500;

export const SET_INTERVAL_PULLING_DATA = 300000;

export const SET_INTERVAL_SYSTEM_OVERVIEW_DIAGRAM = 60000;

export const SET_INTERVAL_SOLAR_WIDGETS = 30000;
